/* =============================================================
   fd-cart-ux.js  —  Cart UX, ATC toast, sticky checkout,
   overlay guard, lightbox fix, savings display
   Fusion Dolls — fusiondolls.com
   ============================================================= */
(function () {
  'use strict';

  var FREE_SHIP_CENTS = 10000;
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }

  var toast = null;
  var toastTimer = null;

  function createToast() {
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'fd-atc-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="fd-atc-toast__tick">&#x2713;</span>' +
      '<div class="fd-atc-toast__info">' +
        '<div class="fd-atc-toast__title">Added to cart</div>' +
        '<div class="fd-atc-toast__msg">Item added successfully</div>' +
      '</div>' +
      '<a href="/cart" class="fd-atc-toast__view">View Cart &rarr;</a>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(title, imgSrc) {
    var t = createToast();
    var titleEl = t.querySelector('.fd-atc-toast__title');
    var msgEl   = t.querySelector('.fd-atc-toast__msg');
    var imgEl   = t.querySelector('.fd-atc-toast__img');

    if (titleEl) titleEl.textContent = title || 'Added to cart';
    if (msgEl)   msgEl.textContent   = 'Item added to your cart';

    if (imgSrc) {
      if (!imgEl) {
        imgEl = document.createElement('img');
        imgEl.className = 'fd-atc-toast__img';
        imgEl.alt = '';
        imgEl.loading = 'lazy';
        t.insertBefore(imgEl, t.firstChild);
      }
      imgEl.src = imgSrc;
    } else if (imgEl) {
      imgEl.remove();
    }

    clearTimeout(toastTimer);
    t.classList.add('fd-atc-toast--visible');
    toastTimer = setTimeout(function () {
      t.classList.remove('fd-atc-toast--visible');
    }, 3500);
  }

  function calcSavings(items) {
    var saved = 0;
    items.forEach(function (item) {
      if (item.compare_at_price && item.compare_at_price > item.final_price) {
        saved += (item.compare_at_price - item.final_price) * item.quantity;
      }
    });
    return saved;
  }

  function injectSavingsBadge(cart) {
    var footer = document.getElementById('fe-cart-footer');
    if (!footer) return;
    var existing = footer.querySelector('.fd-cart-savings');
    if (existing) existing.remove();

    var saved = calcSavings(cart.items);
    if (saved <= 0) return;

    var el = document.createElement('div');
    el.className = 'fd-cart-savings';
    el.innerHTML =
      '<span class="fd-cart-savings__icon">&#x1F4B0;</span>' +
      '<span>You\'re saving <span class="fd-cart-savings__amount">' + fmt(saved) + '</span> on this order!</span>';
    footer.insertBefore(el, footer.firstChild);
  }

  function injectCartMeta() {
    var footer = document.getElementById('fe-cart-footer');
    if (!footer || footer.querySelector('.fd-cart-meta')) return;

    var meta = document.createElement('div');
    meta.className = 'fd-cart-meta';
    meta.innerHTML =
      '<div class="fd-cart-meta__item">' +
        '<span class="fd-cart-meta__icon">&#x1F69A;</span>' +
        '<span class="fd-cart-meta__label">Ships in 1-3 days</span>' +
        '<span class="fd-cart-meta__sub">US orders</span>' +
      '</div>' +
      '<div class="fd-cart-meta__item">' +
        '<span class="fd-cart-meta__icon">&#x1F504;</span>' +
        '<span class="fd-cart-meta__label">30-Day Returns</span>' +
        '<span class="fd-cart-meta__sub"><a href="/policies/refund-policy" style="color:#7B4F8E">Policy</a></span>' +
      '</div>' +
      '<div class="fd-cart-meta__item">' +
        '<span class="fd-cart-meta__icon">&#x1F512;</span>' +
        '<span class="fd-cart-meta__label">Secure checkout</span>' +
        '<span class="fd-cart-meta__sub">256-bit SSL</span>' +
      '</div>';

    var subRow = footer.querySelector('.fe-cart-drawer__subtotal');
    if (subRow) footer.insertBefore(meta, subRow);
    else footer.insertBefore(meta, footer.firstChild);
  }

  function addPctBadges() {
    document.querySelectorAll('.fe-cart-item').forEach(function (item) {
      if (item.querySelector('.fd-cart-item__pct')) return;
      var priceEl = item.querySelector('.fe-cart-item__price--sale');
      if (!priceEl) return;
      var compareEl = item.querySelector('.fe-cart-item__compare');
      if (!compareEl) return;
      var sale    = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
      var compare = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ''));
      if (!sale || !compare || compare <= sale) return;
      var pct = Math.round(((compare - sale) / compare) * 100);
      if (pct <= 0) return;
      var badge = document.createElement('span');
      badge.className = 'fd-cart-item__pct';
      badge.textContent = pct + '% off';
      priceEl.parentNode.insertBefore(badge, priceEl.nextSibling);
    });
  }

  function updateProgress(totalCents) {
    var remaining = FREE_SHIP_CENTS - totalCents;
    var pct = clamp((totalCents / FREE_SHIP_CENTS) * 100, 0, 100);
    document.querySelectorAll('[data-ship-threshold]').forEach(function (bar) {
      var fill = bar.querySelector('.fd-db-progress-fill, .fe-ship-progress__fill');
      var msg  = bar.querySelector('.fd-db-progress-msg, .fe-ship-progress__msg');
      if (!fill || !msg) return;
      fill.style.width = pct + '%';
      if (remaining <= 0) {
        fill.classList.add('fd-db-progress-fill--done');
        msg.innerHTML = '&#x2713; Free shipping unlocked!';
        msg.classList.add('fd-db-progress-msg--done');
      } else {
        fill.classList.remove('fd-db-progress-fill--done');
        msg.innerHTML = 'Add <strong>' + fmt(remaining) + '</strong> more for <strong>FREE shipping</strong>';
        msg.classList.remove('fd-db-progress-msg--done');
      }
    });
    var banner = document.getElementById('fd-ship-banner');
    if (banner) {
      if (remaining <= 0) {
        banner.innerHTML = '&#x2713; You\'ve unlocked <strong>FREE US Shipping!</strong> &nbsp;&#x1F389;' +
          '<button class="fd-ship-banner__close" id="fd-ship-banner-close" aria-label="Close">&times;</button>';
      } else {
        banner.innerHTML = '&#x1F69A; <strong>Free US shipping</strong> on orders over $100 &nbsp;&bull;&nbsp;' +
          '<a href="/collections/all">Shop Now</a>' +
          '<button class="fd-ship-banner__close" id="fd-ship-banner-close" aria-label="Close">&times;</button>';
      }
      var bc = document.getElementById('fd-ship-banner-close');
      if (bc) bc.addEventListener('click', function () {
        banner.style.display = 'none';
        sessionStorage.setItem('fd_ship_banner_closed', '1');
      });
    }
  }

  function initStickyCheckout() {
    if (!document.querySelector('[data-add-to-cart], .product-form')) return;

    var bar = document.getElementById('fd-sticky-checkout');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'fd-sticky-checkout';
      bar.className = 'fd-sticky-checkout';
      bar.innerHTML =
        '<img class="fd-sticky-checkout__thumb" id="fd-sticky-thumb" src="" alt="" style="display:none">' +
        '<span class="fd-sticky-checkout__title" id="fd-sticky-title"></span>' +
        '<button class="fd-sticky-checkout__btn" id="fd-sticky-btn">Checkout &#x2192;</button>';
      document.body.appendChild(bar);
    }

    try {
      var jsonEl = document.querySelector('[data-product-json]');
      if (jsonEl) {
        var pd = JSON.parse(jsonEl.textContent);
        var thumb = document.getElementById('fd-sticky-thumb');
        var titleEl = document.getElementById('fd-sticky-title');
        if (thumb && pd.featured_image) {
          thumb.src = pd.featured_image.replace('http://', 'https://') + '?width=60';
          thumb.style.display = 'block';
        }
        if (titleEl) titleEl.textContent = pd.title || '';
      }
    } catch(e) {}

    var stickyBtn = document.getElementById('fd-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[action*="/cart/add"], .product-form, .ajax-product-form');
        if (!form) { window.location.href = '/checkout'; return; }

        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!idInput || !idInput.value) { window.location.href = '/checkout'; return; }

        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding…';

        var formData = new FormData();
        formData.append('id', idInput.value);
        formData.append('quantity', qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1);

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            window.location.href = '/checkout';
          });
      });
    }

    var payBtn = document.querySelector('[data-add-to-cart], .payment-buttons .btn');
    if (!payBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          bar.classList.add('fd-sticky-checkout--visible');
        } else {
          bar.classList.remove('fd-sticky-checkout--visible');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    observer.observe(payBtn);
  }

  function guardOverlays() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var searchDropdown = document.querySelector('.fd-search-dropdown');
      if (searchDropdown) { searchDropdown.remove(); return; }
      var modal = document.querySelector('.fd-modal');
      if (modal) { modal.remove(); document.body.style.overflow = ''; return; }
      var drawer = document.getElementById('fe-cart-drawer');
      if (drawer && drawer.classList.contains('fe-cart-drawer--open')) {
        drawer.classList.remove('fe-cart-drawer--open');
        var overlay = document.getElementById('fe-cart-overlay');
        if (overlay) { overlay.classList.remove('fe-cart-overlay--open'); }
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('fd:modal:open', function () {});
    document.addEventListener('fd:modal:close', function () {
      var drawer = document.getElementById('fe-cart-drawer');
      if (!drawer || !drawer.classList.contains('fe-cart-drawer--open')) {
        document.body.style.overflow = '';
      }
    });
  }

  function fixLightbox() {
    document.addEventListener('pswpClose', function () {
      document.querySelectorAll('.fe-product-nav, .fe-product-nav__btn').forEach(function (el) {
        el.style.pointerEvents = '';
      });
      document.body.style.overflow = '';
    }, true);

    if (!window.MutationObserver) return;
    var body = document.body;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type !== 'attributes' || m.attributeName !== 'class') return;
        var pswpOpen = body.classList.contains('pswp-open') || !!document.querySelector('.pswp--open');
        document.querySelectorAll('.fe-product-nav, .fe-product-nav__btn').forEach(function (el) {
          el.style.pointerEvents = pswpOpen ? 'none' : '';
        });
      });
    }).observe(body, { attributes: true });

    new MutationObserver(function () {
      document.querySelectorAll('.pswp__button--close:not([data-fd-enlarged])').forEach(function (btn) {
        btn.setAttribute('data-fd-enlarged', '1');
        btn.style.minWidth = '52px';
        btn.style.minHeight = '52px';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function interceptATC() {
    var _busy = false;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form) return;
      var isATC = form.action && form.action.indexOf('/cart/add') !== -1;
      var isAjax = form.classList.contains('ajax-product-form') || form.classList.contains('product-form');
      if (!isATC && !isAjax) return;

      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && (!qtyInput.value || parseInt(qtyInput.value, 10) < 1)) qtyInput.value = 1;

      if (_busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      _busy = true;
      setTimeout(function () { _busy = false; }, 2000);

      var btn    = form.querySelector('[data-add-to-cart],[type="submit"]');
      var textEl = btn ? btn.querySelector('[data-add-to-cart-text]') || btn : null;
      var orig   = textEl ? textEl.textContent.trim() : 'Add to cart';

      var productTitle = '';
      var productImg   = '';
      try {
        var jsonEl = document.querySelector('[data-product-json]');
        if (jsonEl) {
          var pd = JSON.parse(jsonEl.textContent);
          productTitle = pd.title || '';
          productImg   = (pd.featured_image || '').replace('http://', 'https://');
          if (productImg && productImg.indexOf('?') === -1) productImg += '?width=80';
        }
      } catch(ex) {}

      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      if (textEl) textEl.textContent = 'Adding\u2026';

      setTimeout(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
        if (textEl) {
          textEl.textContent = '\u2713 Added!';
          setTimeout(function () { textEl.textContent = orig; }, 2000);
        }
        showToast(productTitle, productImg);

        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          updateProgress(cart.total_price);
          var totalEl = document.getElementById('fd-sticky-total');
          if (totalEl && cart.item_count > 0) totalEl.textContent = fmt(cart.total_price);
          document.querySelectorAll('.header-cart__count,[data-cart-count]').forEach(function(el){
            el.textContent = cart.item_count;
          });
        }).catch(function(){});
      }, 900);
    }, true);

    document.addEventListener('ajaxProduct:added', function (e) {
      var detail = (e && e.detail) || {};
      showToast(detail.productTitle || '', detail.productImage || '');
    });
  }

  function deferCaptcha() {
    var cap = document.querySelector(
      'script[src*="recaptcha"], script[src*="hcaptcha"], script[src*="turnstile"]'
    );
    if (!cap || cap.closest('head')) return;
    cap.setAttribute('defer', '');
    if (!cap.hasAttribute('async')) cap.setAttribute('async', '');
  }

  function boot() {
    try { guardOverlays(); } catch(e) {}
    try { fixLightbox(); } catch(e) {}
    try { interceptATC(); } catch(e) {}
    try { deferCaptcha(); } catch(e) {}

    if (document.querySelector('[data-add-to-cart], .product-form')) {
      // Disabled by request: sticky checkout bar with product image
      // that toggled visible/hidden on scroll near pickup availability.
      // try { initStickyCheckout(); } catch(e) {}
    }

    var footer = document.getElementById('fe-cart-footer');
    if (footer && window.MutationObserver) {
      new MutationObserver(function () {
        fetch('/cart.js').then(function(r){return r.json();})
          .then(function(cart) {
            try { injectSavingsBadge(cart); } catch(e) {}
            try { injectCartMeta(); } catch(e) {}
            try { addPctBadges(); } catch(e) {}
            try { updateProgress(cart.total_price); } catch(e) {}
          }).catch(function(){});
      }).observe(footer, { childList: true, subtree: true, attributes: true });
    }

    fetch('/cart.js').then(function(r){return r.json();})
      .then(function(cart){
        updateProgress(cart.total_price);
        try { injectSavingsBadge(cart); } catch(e) {}
        try { injectCartMeta(); } catch(e) {}
        try { addPctBadges(); } catch(e) {}
      }).catch(function(){});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
